import React from 'react';
import PropTypes from 'prop-types';
import { Trans, translate } from 'react-i18next';
import { ShareButtons } from 'react-share';

import IconDiscount1x from 'assets/images/icon-discount.png';
import IconDiscount2x from 'assets/images/icon-discount@2x.png';

import { formatCurrency } from 'helpers/format';

const {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton
} = ShareButtons;

export const GetDiscount = ({ t, referralCoupon }) => {
  const couponAmount = formatCurrency(
    parseFloat(referralCoupon.coupon.amount, 10),
    referralCoupon.coupon.currency
  );

  const referralBonus = formatCurrency(
    parseFloat(referralCoupon.referralBonus, 10),
    referralCoupon.referralBonusCurrency
  );

  return (
    <div className="row align-center">
      <div className="column small-12 large-8">
        <div className="text-center">
          <img
            src={IconDiscount1x}
            srcSet={`${IconDiscount1x} 1x, ${IconDiscount2x} 2x`}
            alt="Discount"
            className="margin-bottom"
          />

          <Trans parent="p" className="ingress" i18nKey="getDiscount.ingress">
            With referral code you can give
            <strong>{{ couponAmount }}</strong> discount of the first cleaning
            to as many friends as you like. In the process you earn{' '}
            <strong>{{ referralBonus }}</strong> for every new customer that
            books a cleaning using your referral code."
          </Trans>

          <h5>{t('getDiscount.shareOn')}</h5>

          <div className="button-group">
            <FacebookShareButton
              className="button button--full-mobile button--facebook"
              quote={t('getDiscount.shareQuotes.facebook', {
                code: referralCoupon.coupon.code,
                amount: couponAmount
              })}
              url={referralCoupon.coupon.redemptionUrl}
            >
              Facebook
            </FacebookShareButton>{' '}
            <TwitterShareButton
              className="button button--full-mobile button--twitter"
              title={t('getDiscount.shareQuotes.twitter', {
                code: referralCoupon.coupon.code,
                amount: couponAmount
              })}
              url={referralCoupon.coupon.redemptionUrl}
            >
              Twitter
            </TwitterShareButton>{' '}
            <LinkedinShareButton
              className="button button--full-mobile button--linkedin"
              title={t('getDiscount.shareQuotes.linkedin', {
                code: referralCoupon.coupon.code,
                amount: couponAmount
              })}
              url={referralCoupon.coupon.redemptionUrl}
            >
              LinkedIn
            </LinkedinShareButton>
          </div>

          <h5>{t('getDiscount.orSendLinkToFriend')}</h5>

          <p>{referralCoupon.coupon.redemptionUrl}</p>

          <div className="box box--simple box--referral">
            <h5>{t('getDiscount.yourReferralCodeIs')}</h5>
            <h2>{referralCoupon.coupon.code}</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

GetDiscount.propTypes = {
  t: PropTypes.func.isRequired,
  referralCoupon: PropTypes.object.isRequired
};

export default translate()(GetDiscount);



// WEBPACK FOOTER //
// ./src/components/GetDiscount/GetDiscount.js